export default "__VITE_ASSET__UdMS7knM__"